import { render, staticRenderFns } from "./blok-button.vue?vue&type=template&id=f874ca1a&scoped=true"
import script from "./blok-button.vue?vue&type=script&lang=js"
export * from "./blok-button.vue?vue&type=script&lang=js"
import style0 from "./blok-button.vue?vue&type=style&index=0&id=f874ca1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f874ca1a",
  null
  
)

export default component.exports